import * as React from 'react';
import { connect } from 'react-redux';
import IconImage from '../../common/IconImage';
import { ShapeKind, LineType, StampType } from '../../../drawing/types';
import { AppStates } from '../../../reducers/app';
import { ObjectDrawingState } from '../../../reducers/ui/objectDrawing';
import { getBasePath } from '../../../utils/browser';
import { getShapeKindIconName, getColorFilter } from '../../../utils/ui';
import { defaultStamps } from '../../../drawing/constants';
import { Publication } from '../../../types/epub';

interface ObjectDrawingIconImageProps {
  readonly buttonNumber: number;
  readonly objectDrawing: ObjectDrawingState;
  readonly svgStyle?: React.CSSProperties;
  readonly publication: Publication | undefined;
}

const ObjectDrawingIconImage: React.SFC<
  ObjectDrawingIconImageProps
> = (props) => {
  const { buttonNumber, objectDrawing, svgStyle, publication } = props;
  const {
    shapeKind, color, lineWidth, lineType, selectedStampIndex, stampType,
  } = objectDrawing.toolSettings[buttonNumber];

  const baseDir = getBasePath();
  if (shapeKind === ShapeKind.Stamp) {
    let src = '';
    if (stampType === StampType.Default) {
      src = `${baseDir}/${defaultStamps[selectedStampIndex].path}`;
    } else {
      src = publication ?
        `${publication.resourceDir}/${publication.extraStamps[selectedStampIndex].path }` : '';
    }

    return (
      <IconImage
        src={src}
        svgStyle={svgStyle}
      />
    );
  }

  let iconName = `dynamic/shape/icon_shape_${getShapeKindIconName(shapeKind)}`;
  if (
    lineType === LineType.None
    && shapeKind !== ShapeKind.StraightLine
    && shapeKind !== ShapeKind.AxisAlignedStraightLine
  ) {
    iconName += '_paint';
  } else {
    iconName += `_size0${lineWidth}_${lineType === LineType.Solid ? 'solid' : 'dot'}`;
  }

  const src = `${baseDir}/images/tool-icons/${iconName}.png`;
  const iconPositonStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
  };

  return (
    <>
      <IconImage
        src={src}
        svgStyle={{ ...iconPositonStyle, ...svgStyle }}
      />
      <IconImage
        src={src}
        svgStyle={{ ...iconPositonStyle, ...svgStyle }}
        {...getColorFilter(color)}
      />
    </>
  );
};

const mapStateToProps = (appStates: AppStates) => {
  return {
    objectDrawing: appStates.ui.objectDrawing,
    publication : appStates.publication,
  };
};

export default connect(mapStateToProps)(ObjectDrawingIconImage);
